module.exports = __webpack_public_path__ + "static/media/Check.0055ec05.svg";